<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MobileMenuItem from './MobileMenuItem.vue'
import type { NavigationMenuItem } from './types'
import mdiStar from '~icons/mdi/star'
import mdiCog from '~icons/mdi/cog'
import mdiLogout from '~icons/mdi/logout'

const { t } = useI18n()

const props = defineProps<{
  items: NavigationMenuItem[]
}>()

const drawer = defineModel<boolean>('drawer', { required: true })

const emit = defineEmits<{
  'select': [item: NavigationMenuItem]
  'open:starredItems': []
  'open:settings': []
  'logout': []
}>()

const menuData = computed(() =>
  props.items.map((item) => ({
    ...item,
    children: item.sub_menu ?? [],
  }))
)

const openedGroups = ref<string[]>([])

function onSelect(item: NavigationMenuItem) {
  emit('select', item)
  drawer.value = false
}

function openStarredItems() {
  emit('open:starredItems')
  drawer.value = false
}

function openSettings() {
  emit('open:settings')
  drawer.value = false
}

function logout() {
  emit('logout')
  drawer.value = false
}
</script>

<template>
  <nav
    v-if="drawer"
    class="d-flex flex-column h-100 d-lg-none"
    :aria-label="t('common.navigation_menu')"
  >
    <v-list
      v-model:opened="openedGroups"
      density="compact"
      role="menu"
      class="flex-grow-1 overflow-y-auto"
    >
      <template
        v-for="item in menuData"
        :key="item.locale_name"
      >
        <mobile-menu-item
          :item="item"
          @select="onSelect"
        />
        <v-divider />
      </template>
    </v-list>

    <div>
      <v-list density="compact">
        <v-list-item
          :prepend-icon="mdiStar"
          :title="t('common.watch_list')"
          @click="openStarredItems"
        />
        <v-list-item
          :prepend-icon="mdiCog"
          :title="t('common.settings')"
          @click="openSettings"
        />
        <v-divider class="my-2" />
        <v-list-item
          :prepend-icon="mdiLogout"
          :title="t('common.logout')"
          @click="logout"
        />
      </v-list>
    </div>
  </nav>
</template>
